module.exports = __webpack_public_path__ + "static/media/icomoon.8251ea2a.woff";